import { render, staticRenderFns } from "./CreateMaterialContainer.vue?vue&type=template&id=32cb5346"
import script from "./CreateMaterialContainer.vue?vue&type=script&lang=js"
export * from "./CreateMaterialContainer.vue?vue&type=script&lang=js"
import style0 from "./CreateMaterialContainer.vue?vue&type=style&index=0&id=32cb5346&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports